const axios = require("axios");

export const ApiClient = axios.create();
ApiClient.defaults.withCredentials = true;

export const AuthClient = axios.create();
